import React, { createContext, useState, useContext, ReactNode } from 'react';

type AuthModalState = 'login' | 'signup';
type AccountType = 'student' | 'teacher';

interface AuthModalContextType {
  isAuthModalOpen: boolean;
  authModalInitialState: AuthModalState;
  authModalInitialAccountType: AccountType;
  openAuthModal: (initialState?: AuthModalState, initialAccountType?: AccountType) => void;
  closeAuthModal: () => void;
}

const AuthModalContext = createContext<AuthModalContextType | undefined>(undefined);

export const AuthModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isAuthModalOpen, setAuthModalOpen] = useState(false);
  const [authModalInitialState, setAuthModalInitialState] = useState<AuthModalState>('login');
  const [authModalInitialAccountType, setAuthModalInitialAccountType] = useState<AccountType>('student');

  const openAuthModal = (initialState: AuthModalState = 'login', initialAccountType: AccountType = 'student') => {
    setAuthModalInitialState(initialState);
    setAuthModalInitialAccountType(initialAccountType);
    setAuthModalOpen(true);
  };

  const closeAuthModal = () => {
    setAuthModalOpen(false);
  };

  return (
    <AuthModalContext.Provider value={{ isAuthModalOpen, authModalInitialState, authModalInitialAccountType, openAuthModal, closeAuthModal }}>
      {children}
    </AuthModalContext.Provider>
  );
};

export const useAuthModal = () => {
  const context = useContext(AuthModalContext);
  if (context === undefined) {
    throw new Error('useAuthModal must be used within an AuthModalProvider');
  }
  return context;
};
